
// Using the automatic JSX runtime - no default React import required
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './Layout';
import Dashboard from '../screens/Dashboard';
import DataManagement from '../screens/DataManagement';
import Reports from '../screens/Reports';
import Settings from '../screens/Settings';
import Analytics from '../screens/Analytics';
import Users from '../screens/Users';
import SyncStatus from '../screens/SyncStatus';
import PTPDashboard from '../screens/PTPDashboard';
import PTPCreate from '../screens/PTPCreate';
import PTPReview from '../screens/PTPReview';
import PTPApprove from '../screens/PTPApprove';
import PTPAnalytics from '../screens/PTPAnalytics';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

interface AuthenticatedAppProps {
  user: any;
  signOut: () => void;
}

export default function AuthenticatedApp({ user, signOut }: AuthenticatedAppProps) {
  const isOnline = useNetworkStatus();

  return (
    <Router>
      <Layout user={user} signOut={signOut}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/data" element={<DataManagement />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/users" element={<Users />} />
          <Route path="/sync" element={<SyncStatus />} />
          <Route path="/settings" element={<Settings />} />
          {/* PTP Routes */}
          <Route path="/ptp" element={<PTPDashboard />} />
          <Route path="/ptp/create" element={<PTPCreate />} />
          <Route path="/ptp/:id" element={<PTPReview />} />
          <Route path="/ptp/:id/edit" element={<PTPCreate />} />
          <Route path="/ptp/:id/review" element={<PTPReview />} />
          <Route path="/ptp/:id/approve" element={<PTPApprove />} />
          <Route path="/ptp/analytics" element={<PTPAnalytics />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {!isOnline && (
          <div className="offline-banner">
            <span>⚠️ You are currently offline. Changes will sync when connection is restored.</span>
          </div>
        )}
      </Layout>
    </Router>
  );
}
